'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function SRFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-0tbkgcvb0", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-0tbkgcvb0)" }, /* @__PURE__ */ React.createElement("path", { fill: "#4e8b1d", d: "M0 16h32v8H0zM0 0h32v6H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#af0100", stroke: "#fff", strokeWidth: "3", d: "M33.5 6.5v11h-35v-11z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        d: "M16.002 14.494L13.508 16l.57-2.938-2.078-2.2 2.812-.118L16.002 8l1.19 2.744H20l-2.072 2.318.624 2.938z"
      }
    )))
  );
}

export { SRFlag };
//# sourceMappingURL=SR.mjs.map
